/* eslint-disable no-restricted-globals */
/* eslint-disable space-before-blocks */
/* eslint-disable import/extensions */
/* eslint-disable template-tag-spacing */
/* eslint-disable radix */
/* eslint-disable no-case-declarations */
import lscache from 'lscache';
import { auth, } from '@/services/auth';
import { extract, generator } from './utils';
import { constant } from './constant';

export const version = {
  site: 'v3.0.0',
  crm: 'v1.6.1',
};

export const env = () => {
  let env = process.env.ENVIRONMENT;
  if (env) {
    return env;
  }
  const api = process.env.API_URL;
  env = 'production';
  if (api.indexOf('sitepreview.') !== -1) {
    env = 'preview';
  }
  if (api.indexOf('site.') !== -1) {
    env = 'production';
  }
  return env;
};

export const store = {
  set: (key, value) => {
    if (value) {
      lscache.set(key, value);
    }
    return value;
  },
  get: (key) => lscache.get(key),
  remove: (key) => lscache.remove(key),
  notifications: {
    updates: {
      set: (value) => {
        if (value) {
          store.set('notifications-updates', value);
        }
        return value;
      },
      get: () => store.get('notifications-updates'),
      remove: () => store.remove('notifications-updates'),
    },
  },
  menu: {
    crm: {
      set: (value) => {
        if (value) {
          store.set('crm-menu', value);
        }
        return value;
      },
      get: () => store.get('crm-menu'),
      remove: () => store.remove('crm-menu'),
    },
  },
  filter: {
    set: (value, key) => {
      if (value) {
        store.set(`filter${key ?? ''}`, value);
      }
      return value;
    },
    get: (key) => store.get(`filter${key ?? ''}`),
    remove: (key) => store.remove(`filter${key ?? ''}`),
  },
  customer: {
    set: (value) => {
      if (value) {
        lscache.set('customer', value);
      }
      return value;
    },
    get: () => lscache.get('customer'),
    remove: () => lscache.remove('customer'),
  },
};

export const notification = {
  dispatch: () => { },
  configure: (dispatch) => {
    notification.dispatch = dispatch;
  },
  reduce: (state, action) => {
    if (action.type === 'close') {
      delete state.show;
      delete state.type;
      delete state.message;
      return { ...state };
    }
    const classes = {
      alert: 'modal-header-warning',
      delete: 'modal-header-danger',
    };
    state.show = true;
    state.message = action.message;
    state.type = action.type;
    state.class = classes[action.type];
    state.title = action.title;
    state.yes = action.yes;
    state.no = action.no;
    return { ...state };
  },
  init: () => ({
    show: false,
    notification: {},
  }),
  confirm: (message, yes, no) => {
    notification.dispatch({ type: 'confirm', message, yes, no, });
  },
  alert: (message) => {
    notification.dispatch({ type: 'alert', message, });
  },
  delete: (message, yes, no) => {
    notification.dispatch({ type: 'delete', title: 'Excluir?', message, yes, no, });
  },
  close: () => {
    notification.dispatch({ type: 'close' });
  },
};

export const messages = {
  dispatch: () => { },
  configure: (dispatch) => {
    messages.dispatch = dispatch;
  },
  reduce: (state, action) => {
    if (action.type === 'clear') {
      store.remove('messages');
      let newMessages = [];
      if (typeof action.id !== 'undefined') {
        newMessages = state.messages.filter((item) => item.id !== action.id);
      } else if (typeof action.index !== 'undefined') {
        newMessages = state.messages.filter((_, index) => index !== action.index);
      }
      return {
        ...state,
        messages: newMessages,
      };
    }
    const newMessage = {
      id: action.id || generator.token(),
      message: action.message,
      type: action.type,
      toast: action.toast,
      title: action.title,
    };
    const newMessages = [...state.messages, newMessage];
    if (action.save) {
      store.set('messages', newMessages, 60 * 8);
    }
    if (!action.toast && action.type !== 'clear') {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
    return {
      ...state,
      messages: newMessages,
    };
  },
  init: () => ({
    messages: [],
  }),
  message: (message, type, save, toast, title) => {
    messages.dispatch({ type, message, save, toast, title });
  },
  success: (text, save, toast) => {
    messages.message(text, 'success', save, toast);
  },
  error: (text, save, toast) => {
    messages.message(text, 'danger', save, toast);
  },
  info: (text, save, toast) => {
    messages.message(text, 'info', save, toast);
  },
  alert: (text, save, toast) => {
    messages.message(text, 'warning', save, toast);
  },
  clear: (target) => {
    if (typeof target === 'string') {
      messages.dispatch({
        type: 'clear',
        id: target,
      });
    } else if (typeof target === 'object' && target?.id) {
      messages.dispatch({
        type: 'clear',
        id: target.id,
      });
    } else {
      messages.dispatch({
        type: 'clear',
        index: target,
      });
    }
  },
};

export const layout = {
  menu: {
    close: () => {
      const element = document.getElementsByClassName('navbar-collapse collapse show');
      const toggler = document.getElementsByClassName('navbar-toggler');
      if (element.length === 0 || toggler.length === 0) {
        return;
      }
      toggler[0].click();
    },
  },
  print: () => window.print(),
  login: {},
  cart: {
    show: (show) => {
      setTimeout(() => {
        const element = document.getElementById('cart');
        if (!element) {
          return;
        }
        const checkout = document.getElementById('cart-checkout');
        const payment = document.getElementById('cart-payment');
        if (checkout ?? payment) {
          element.style.display = 'none';
          return;
        }
        if (!show) {
          show = !element.style.display || element.style.display === 'none';
        }
        if (show) {
          messages.clear();
        }
        element.style.display = show ? 'block' : 'none';
        layout.menu.close();
      }, 100);
    },
  },
  help: {
    control: (display) => {
      setTimeout(() => {
        const element = document.getElementById('help');
        if (!element) { return; }
        messages.clear();
        element.style.display = display;
        if (display === 'flex') {
          element.classList.add('help');
        }
        if (display === 'none') {
          element.classList.remove('help');
        }
        layout.menu.close();
      }, 100);
    },
    show: () => {
      layout.help.control('flex');
    },
    close: () => {
      layout.help.control('none');
    },
  },
  loading: (show, message) => {
    setTimeout(() => {
      const element = document.getElementById('loading');
      if (!element) {
        return;
      }
      const elementMessage = document.getElementById('loading-message');
      if (elementMessage) {
        elementMessage.innerHTML = message ?? '&nbsp;';
      }
      if (typeof show === 'undefined') {
        show = !element.style.display || element.style.display === 'none';
      }
      element.style.display = show ? 'block' : 'none';
      layout.menu.close();
    }, 100);
  },
  focus: (id, delay, select) => {
    setTimeout(() => {
      const element = document.getElementById(id);
      if (element) {
        element.focus();
        if (select && element.select) {
          element.select();
        }
      }
    }, delay ?? 100);
  },
  nameFocus: (name, delay, select) => {
    setTimeout(() => {
      const element = document.getElementsByName(name)[0];
      if (element) {
        element.focus();
        if (select && element.select) {
          element.select();
        }
      }
    }, delay ?? 100);
  },
  inputValue: (id, value, delay) => {
    setTimeout(() => {
      const element = document.getElementById(id);
      if (element) {
        element.value = value;
      }
    }, delay ?? 100);
  },
  back: {
    set: (value) => {
      if (value) {
        store.set('back', value);
      }
    },
    get: () => store.get('back'),
    remove: () => {
      store.remove('back');
    },
  },
  inquiry: {
    set: (value) => {
      if (value) {
        store.set('inquiry', value);
      }
    },
    get: () => store.get('inquiry'),
    remove: () => {
      store.remove('inquiry');
    },
  },
  route: {
    set: (value) => {
      if (value) {
        if (value.indexOf('/crm') === 0 || value.indexOf('/perfil') === 0) {
          store.filter.remove();
        }
        store.set('route', value);
      }
    },
    get: () => store.get('route'),
    remove: () => {
      store.remove('route');
    },
  },
};

export const loading = {
  css: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  color: '#0098db',
  reduce: (state, action) => {
    switch (action.type) {
      case 'SHOW':
        state.show = true;
        return {
          ...state,
        };
      case 'HIDE':
        state.show = false;
        return {
          ...state,
        };
      default:
        return state;
    }
  },
  show: true,
};

export const http = {
  data: (method, body, form, headers) => {
    const data = {
      method,
      headers: headers || {},
    };
    if (!form) {
      data.headers['Content-Type'] = 'application/json';
    }
    if (body) {
      data.body = form ? body : JSON.stringify(body);
    }
    if (auth.store.token.get()) {
      data.headers.authorization = `Bearer ${auth.store.token.get()}`;
    }
    return data;
  },
  base: (method, uri, body, callback, form, headers) => {
    fetch(`${process.env.API_URL}/v1${uri}`, http.data(method, body, form, headers)).then(async (res) => {
      const { pathname } = window.location;
      if (res.status === 401 && uri.indexOf('/auth/invalidate') === -1) {
        if (pathname !== constant.redirect.login && pathname !== '/') {
          auth.logout();
          window.location.href = constant.redirect.login;
          return;
        }
      }
      const result = await res.json();
      if (res.ok) {
        callback(result);
        return;
      }
      callback(null, result, res.status);
    }).catch((err) => {
      callback(null, err);
    });
  },
  generic: (method, uri, body, callback, form) => {
    fetch(`${process.env.API_URL}/v1${uri}`, http.data(method, body, form)).then(async (res) => {
      callback(res);
    }).catch((err) => {
      callback(null, err);
    });
  },
  baseAsync: (method, uri, body, form, headers) => fetch(`${process.env.API_URL}/v1${uri}`, http.data(method, body, form, headers)),
  get: (uri, callback, headers) => http.base('GET', uri, null, callback, null, headers),
  post: (uri, body, callback, form, headers) => http.base('POST', uri, body, callback, form, headers),
  put: (uri, body, callback, form, headers) => http.base('PUT', uri, body, callback, form, headers),
  patch: (uri, body, callback, form, headers) => http.base('PATCH', uri, body, callback, form, headers),
  delete: (uri, body, callback, headers) => http.base('DELETE', uri, body, callback, headers),
};

export const cart = {
  dispatch: () => { },
  configure: (dispatch) => {
    cart.dispatch = dispatch;
  },
  init: () => ({
    items: [],
    balance: 0.00,
    total: 0.00,
    quantity: 0,
    coupon: null,
  }),
  coupon: async (e) => {
    e.preventDefault();
    messages.clear();
    layout.loading(true);
    const code = e.currentTarget.coupon.value;
    http.get(`/coupons/${code.toUpperCase()}`, (result) => {
      layout.loading(false);
      if (!result) {
        messages.error('Cupom inválido.', false, true);
        cart.dispatch({
          type: 'COUPON',
        });
        return;
      }
      cart.dispatch({
        type: 'COUPON',
        payload: result,
      });
      e.target.reset();
      messages.success('Cupom aplicado.', false, true);
    });
  },
  add: (index) => {
    cart.dispatch({
      type: 'ADD',
      payload: index,
    });
  },
  remove: (index) => {
    cart.dispatch({
      type: 'REMOVE',
      payload: index,
    });
  },
  balance: (state) => {
    state.total = 0.00;
    state.balance = 0.00;
    state.quantity = 0;
    state.discount = 0;
    state.items.forEach((item) => {
      if (!state.coupon && !item.plan) {
        item.discount = 0;
      }
      if (!item.plan && state.coupon) {
        item.discount = state.coupon.discount;
      }
      const value = item.discount ? item.value - (item.value * item.discount) : item.value;
      state.discount += (item.value * item.discount) * item.quantity;
      state.balance += value * item.quantity;
      state.total += item.value * item.quantity;
      state.quantity += item.quantity;
    });
  },
  reduce: (state, action) => {
    const add = () => {
      let addItem = action.payload;
      if (typeof addItem === 'number') {
        addItem = state.items[addItem];
      }
      const exists = state.items.find((value) => value.name === addItem.name);
      if (exists) {
        exists.quantity += 1;
      } else {
        addItem.quantity = 1;
        state.items.push(addItem);
      }
    };
    const remove = () => {
      const removeItem = state.items[action.payload];
      if (removeItem.quantity > 1) {
        removeItem.quantity -= 1;
      } else {
        state.items.splice(action.payload, 1);
      }
    };
    switch (action.type) {
      case 'ADD':
        add();
        cart.balance(state);
        store.set('cart', state);
        layout.cart.show(true);
        return {
          ...state,
        };
      case 'REMOVE':
        remove();
        if (state.items.length === 0) {
          store.remove('cart');
          state = cart.init();
          return {
            ...state,
          };
        }
        cart.balance(state);
        store.set('cart', state);
        return {
          ...state,
        };
      case 'CLEAR':
        store.remove('cart');
        state = cart.init();
        return {
          ...state,
        };
      case 'LOAD':
        state = store.get('cart') ?? cart.init();
        cart.balance(state);
        return {
          ...state,
        };
      case 'COUPON':
        state.coupon = action.payload;
        cart.balance(state);
        store.set('cart', state);
        return {
          ...state,
        };
      default:
        return state;
    }
  },
};

export const help = {
  dispatch: () => { },
  configure: (dispatch) => {
    help.dispatch = dispatch;
  },
  init: () => ({
    items: [],
    context: '',
    tab: '',
  }),
  show: (context) => {
    help.dispatch({
      type: 'SHOW',
      payload: context,
    });
    layout.help.show();
  },
  close: () => {
    help.dispatch({
      type: 'CLOSE'
    });
    layout.help.close();
  },
  reduce: (state, action) => {
    switch (action.type) {
      case 'SHOW':
        state.context = action.payload;
        return { ...state, };
      case 'CLOSE':
        return { ...state, };
      case 'LOAD':
        state.items = action.payload;
        return { ...state, };
      default:
        return state;
    }
  },
};

export const controller = {
  customer: {
    filterOn: ['users', 'histories', 'orders', 'flows'],
  },
  configure: (options) => {
    const cachePrefix = options.cachePrefix ?? 'crm';
    const cacheKey = options.cacheKey ?? `-${cachePrefix}-${options.name}`;
    const filter = options.filter ?? store.filter.get(cacheKey) ?? {};
    const config = {
      name: options.name,
      prefix: options.prefix,
      filter,
      cachePrefix,
      cacheKey,
      exportName: options.exportName ?? (() => 'export.csv'),
      i18n: {
        coupons: 'cupons',
        history: 'historico-utilizacao',
        inquiries: 'servicos',
        logs: 'logs',
        orders: 'compras',
        users: 'usuarios',
        blacklist: 'blacklist',
        templates: 'templates',
        campaigns: 'campanhas',
        prospects: 'prospeccoes',
        communications: 'comunicacoes-venda',
      },
      setItems: options.setItems,
      setAggregate: options.setAggregate,
      setTotal: options.setTotal,
      setPages: options.setPages,
      setPage: options.setPage,
      callback: options.callback,
      prepare: (pageNumber, exportable) => {
        const customer = store.customer.get();
        const cacheFilter = store.filter.get(config.cacheKey);
        if (cacheFilter && Object.keys(cacheFilter).length > 0) {
          config.filter = cacheFilter;
        }
        if (
          customer
          && controller.customer.filterOn.indexOf(config.name) !== -1
          && !config.filter.term
        ) {
          config.filter.term = customer.email;
        }
        window.scrollTo(0, 0);
        layout.loading(true);
        messages.clear();
        const params = [];
        if (typeof config.filter === 'object') {
          Object.keys(config.filter).forEach((key) => {
            params.push(`${key}=${config.filter[key]}`);
          });
        }
        if (config.setPages) {
          params.push(`page=${pageNumber ?? 1}`);
        }
        if (exportable) {
          params.push(`exportable=${exportable}`);
        }
        let firstParam = '';
        if (config.name.indexOf('?') === -1) {
          firstParam = '?';
        }
        if (config.name.indexOf('?') !== -1 && params.length > 0) {
          firstParam = '&';
        }
        return `${config.prefix ? config.prefix : '/manager/'}${config.name}${firstParam}${params.join('&')}`;
      },
      mount: (key, value) => () => { config.filterIt(key, value); },
      filterMount: (name, check) => (e) => {
        config.filterIt(name, check ? e.target.checked : e.target.value);
      },
      filterClear: (key) => {
        delete config.filter[key];
      },
      filterIt: (key, value, ignore) => {
        if (value) {
          config.filter[key] = value;
        } else {
          delete config.filter[key];
          layout.inputValue(key, '');
        }
        if (config.setPages) {
          config.setPage(1);
        }
        store.filter.set(config.filter, config.cacheKey);
        if (!ignore) {
          config.load();
        }
      },
      export: (pageNumber) => {
        const download = (content, fileName, mimeType) => {
          const a = document.createElement('a');
          mimeType = mimeType ?? 'application/octet-stream';
          if (navigator.msSaveBlob) {
            navigator.msSaveBlob(new Blob([content], {
              type: mimeType,
            }), fileName);
          } else if (URL && 'download' in a) {
            a.href = URL.createObjectURL(new Blob([content], {
              type: mimeType,
            }));
            a.setAttribute('download', fileName);
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          } else {
            location.href = `data:application/octet-stream,${encodeURIComponent(content)}`;
          }
        };
        http.generic('GET', config.prepare(pageNumber, 'csv'), null, async (result) => {
          layout.loading(false);
          const csv = await result.text();
          if (!csv) {
            return;
          }
          download(extract.normalize(csv).replace(/"/g, ''), config.exportName(), 'text/csv;encoding:utf-8');
        });
      },
      load: async (pageNumber, callback) => {
        http.get(config.prepare(pageNumber), (result, resultError, status) => {
          if (resultError) {
            if (status === 401) {
              layout.back.set(`/crm/${config.i18n[config.name]}`);
              auth.logout();
              window.location.href = constant.redirect.login;
              return;
            }
            if (resultError.message && (resultError.message.indexOf('Failed to fetch') !== -1 || resultError.message.indexOf('Unexpected token') !== -1)) {
              window.location.reload();
              return;
            }
            messages.error(resultError.message, false, true);
            layout.loading(false);
            return;
          }
          if (result) {
            if (!config.setPages) {
              config.setItems(result);
              config.setTotal(result.length);
            } else {
              config.setItems(result.docs);
              config.setTotal(result.totalDocs);
              config.setPage(parseInt(result.page));
              config.setPages(result.totalPages);
            }
            layout.loading(false);
            if (callback) {
              callback(result);
            }
            if (config.callback) {
              config.callback(result);
            }
          }
        });
      },
      delete: (id) => {
        notification.delete('Deseja realmente excluir esse registro?', () => {
          messages.clear();
          if (!id) {
            messages.error('Por favor, informe o ID do registro.', false, true);
            return;
          }
          layout.loading(true);
          http.delete(`/manager/${config.name}/${id}`, null, (result, resultError) => {
            if (result) {
              config.load();
              messages.success('Registro excluido com sucesso.', false, true);
              layout.loading(false);
              return;
            }
            messages.error(resultError.message, false, true);
            layout.loading(false);
          });
        });
      },
    };
    const cache = store.filter.get(config.cacheKey);
    if (cache && Object.keys(cache).length > 0 && Object.keys(config.filter).length === 0) {
      config.filter = cache;
    }
    if (window && controller.customer.filterOn.indexOf(config.name) !== -1) {
      window.crm = { toolbar: { manager: config, }, };
    }
    return config;
  },
};

export * from './report';
export * from './report-filter';
export * from './response';
export * from './utils';
